<template>
  <div>
    <el-button
      v-if="modelo === 'flat'"
      @click="cancelarConsulta"
      class="__btn_cancelar_consulta"
    >
      <i class="el-icon el-icon-close"></i> cancelar
    </el-button>
    <el-button
      v-if="modelo === 'switch'"
      @click="cancelarConsulta"
      class="__btn_confirmar_presenca__switch"
    >
      <div class="body">
        <i class="el-icon el-icon-circle-close"></i>
        <span>cancelar consulta</span>
      </div>
    </el-button>
  </div>
</template>
<script>

export default {
  name: 'CancelarConsultaBtn',
  props: {
    modelo: {
      type: String,
      default: 'flat'
    },
    cancelarConsulta: {
      type: Function,
      required: true
    }
  }
}
</script>
<style lang="less" scoped>
.__btn_cancelar_consulta {
  background: #E33333 0% 0% no-repeat padding-box;
  border: 1px solid #E33333;
  font: normal normal 600 11px/15px Open Sans;
  color: #FFFFFF;
  text-transform: uppercase;
  padding: 7px 12px;
  height: 29px;
  border-radius: 5px;
}

.__btn_confirmar_presenca__switch {
  background: #E33333 0% 0% no-repeat padding-box;
  border: 1px solid #E33333;
  font: normal normal 600 11px/15px Open Sans;
  color: #FFFFFF;
  text-transform: uppercase;
  padding: 7px 12px;
  height: 54px;
  border-radius: 5px;
  width: 163px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .body {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: break-spaces;

    i {
      font-size: 28px;
    }

    span {
      text-align: left;
      font: normal normal 600 12px/17px Open Sans;
      letter-spacing: 0px;
      color: #FFFFFF;
      text-transform: uppercase;
      word-wrap: break-word;
    }
  }
}

</style>
